<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Dashboard</span>
        <h3 class="page-title">Article Analytics</h3>
      </d-col>
    </d-row>
    <d-row>
      <d-col lg="10" md="12" sm="12" class="mb-4">
        <d-card class="card-small">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <h6 class="m-0">Top Referrals</h6>
            <div class="block-handle"></div>
          </d-card-header>
          <d-card-body class="p-0">
            <!-- Top Referrals List Group -->
            <d-list-group flush class="list-group-small">
              <d-list-group-item
                v-for="(item, idx) in article"
                :key="idx"
                class="d-flex px-3"
              >
                <span class="text-semibold text-fiord-blue">{{
                  item.title
                }}</span>
                <span
                  class="ml-auto text-right text-semibold text-reagent-gray"
                  >{{ item.views }}</span
                >
              </d-list-group-item>
            </d-list-group>
          </d-card-body>
          <d-card-footer class="border-top">
            <d-row> </d-row>
          </d-card-footer>
        </d-card>
      </d-col>
      <d-col lg="10" md="12" sm="12" class="mb-4">
        <div class="card card-small h-100">
          <!-- Card Header -->
          <div class="card-header border-bottom">
            <h6 class="m-0">Category</h6>
          </div>
          <!-- Chart -->
          <div class="card-body d-flex py-0">
            <canvas ref="canvas" class="blog-users-by-device m-auto"></canvas>
          </div>
          <d-card-footer class="border-top"> </d-card-footer>
        </div>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import axios from "axios";
import Chart from "../utils/chart";

export default {
  name: "users-by-device",
  data() {
    return {
      datasets: [],
      article: [],
      savetop3ViewsArticles: [],
      savedataByCategories: [],
    };
  },
  mounted() {
    this.onpageload();
  },
  methods: {
    init() {
      var temp;
      var a;
      for (
        var top3count = 0;
        top3count < this.savetop3ViewsArticles.length;
        top3count++
      ) {
        temp = { title: this.savetop3ViewsArticles[top3count], views: "12" };
        this.article.push(temp);
      }
      this.datasets = [
        {
          hoverBorderColor: "#ffffff",
          data: [68.3, 24.2, 7.5],
          backgroundColor: [
            "rgba(0,123,255,0.9)",
            "rgba(0,123,255,0.5)",
            "rgba(0,123,255,0.3)",
          ],
        },
      ];

      //柱形图
      var tempcat = [],
        tempdata = [];
      for (
        var savecat = 0;
        savecat < this.savedataByCategories.length;
        savecat++
      ) {
        tempcat[savecat] = this.savedataByCategories[savecat].category;
        tempdata[savecat] = this.savedataByCategories[savecat].views;
      }
      const defaultChartData = {
        datasets: [
          {
            label: "Category View",
            hoverBorderColor: "#ffffff",
            data: tempdata,
            backgroundColor: [
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 15)",
              "rgba(34,52,78, 1)",
            ],
          },
        ],
        labels: tempcat,
      };

      const chartConfig = {
        type: "bar",
        data: defaultChartData,
        options: {
          responsive: true,
          legend: {
            labels: {
              fontColor: "black",
              fontSize: 12,
            },
          },
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "Chart.js Bar Chart",
            },
          },
        },
      };

      new Chart(this.$refs.canvas, chartConfig);
    },

    onpageload() {
      axios
        .get(process.env.VUE_APP_API + "api/staff/Report/article")
        .then((response) => {
          this.savetop3ViewsArticles = response.data.result.top3ViewsArticles;
          this.savedataByCategories = response.data.result.dataByCategories;
          this.init(); // set value load
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.toprefmain {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.topref_box {
  border-style: solid;
  border-width: 3px;
  border-style: solid;
  border-color: rgba(238, 245.03, 255, 1);
  display: inline;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.topref_boxcon {
  width: auto;
  height: 160px;
  padding: 35px;
  background-color: rgba(63.3, 116.69, 192.31, 1);
  border-style: solid;
  border-width: 3px;
  border-style: solid;
  border-color: white;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 100%;
  text-align: center;
  color: white;
}

.topref_boxconhead {
  font-size: 12px;
  font-weight: 700;
  line-height: 100%;
  text-align: center;
  color: white;
}

.topref_boxconbody {
  font-size: 48px;
  font-weight: 700;
  line-height: 100%;
  text-align: center;
  color: white;
}

.topref_box_two {
}

.bookingcanvas {
  background-color: rgb(34, 52, 78);
  width: 100%;
}
</style>